import { PAGE_INDICES } from '../../actions/eaTravelRates/types';
import {
    SET_ACTIVE_PAGE_INDEX,
    SET_NAVIGATION_DONE,
    NAVIGATE_TO_LOGIN,
    NAVIGATE_TO_UPDATE,
} from '../../actions/eaTravelRates/routing';

export const initRouting = {
    activePageIndex: 0,
    doNavigation: false,
    doExitNavigation: false,
    landingPage: null,
};

export default (state = initRouting, action) => {
    const setActivePage = (pageIndex) => ({
        ...state,
        activePageIndex: pageIndex,
        doNavigation: true,
    });

    switch (action.type) {
        case SET_ACTIVE_PAGE_INDEX:
            return {
                ...state,
                doNavigation: true,
                activePageIndex: action.value,
            };
        case SET_NAVIGATION_DONE:
            return { ...state, doNavigation: false };
        case NAVIGATE_TO_LOGIN:
            return setActivePage(PAGE_INDICES.LOGIN);
        case NAVIGATE_TO_UPDATE:
            return setActivePage(PAGE_INDICES.UPDATE);

        default:
            return state;
    }
};
